<template>
  <van-nav-bar
    title="工单详情"
    left-text="返回"
    left-arrow
    fixed
    placeholder
    @click-left="onClickLeft"
  />
  <div class="detail" v-if="detail.id">
    <div class="inner">
      <van-cell-group>
        <van-field label="报修时间" v-model="detail.fault_time_name" readonly />
        <van-field
          v-if="detail.store_name"
          label="所属店铺"
          v-model="detail.store_name"
          readonly
        />
        <van-field
          label="报修人"
          v-model="repairName"
          readonly
          right-icon="column"
        >
          <template #right-icon>
            <van-icon
              name="column"
              color="#3eaaf7"
              size="20"
              @click="showLog = true"
            />
          </template>
        </van-field>
        <van-field label="回访电话" readonly>
          <template #input>
            <a
              :href="`tel:${detail.fault_mobile_number}`"
              style="color: #1989fa"
            >
              {{ detail.fault_mobile_number }}
            </a>
          </template>
        </van-field>
      </van-cell-group>
      <van-cell-group style="margin-top: 10px">
        <van-field label="工单编号" v-model="detail.order_code" readonly>
          <template #extra>
            <van-button
              round
              size="mini"
              :color="colors[detail.progre_state - 1]"
              >{{ detail.progre_state_name }}</van-button
            >
          </template>
        </van-field>
        <van-field label="紧急程度" v-model="detail.rlevel_name" readonly />
        <van-field label="故障类型" readonly>
          <template #input>
            <van-button
              round
              size="mini"
              v-for="(type, index) in detail.faulttype_full_name.split(',')"
              :color="colors[0]"
              :key="index"
              >{{ type }}</van-button
            >
          </template>
        </van-field>
        <van-field
          v-if="detail.appointment_time_name"
          label="预约时间"
          v-model="detail.appointment_time_name"
          readonly
        />
        <van-field label="位置信息" v-model="detail.place_full_name" readonly />
        <van-field
          label="设备信息"
          v-if="detail.device_con?.device_name"
          v-model="detail.device_con.device_name"
          readonly
        />
        <van-field
          v-model="detail.fault_note"
          rows="4"
          autosize
          label="报修内容"
          type="textarea"
          show-word-limit
          readonly
        />
        <van-field
          v-model="detail.note_text"
          rows="4"
          autosize
          label="备注信息"
          type="textarea"
          show-word-limit
          readonly
        />
        <van-field
          label="现场图片"
          v-if="detail.fault_file_jpg_arr.length !== 0"
        >
          <template #input>
            <div style="width: 100%">
              <van-image
                style="margin-right: 5px"
                v-for="(file, index) in detail.fault_file_jpg_arr"
                width="75"
                height="75"
                fit="cover"
                :key="index"
                :src="file.file_path"
                @click="
                  ImagePreview({
                    images: detail.fault_file_jpg_arr.map(
                      (file) => file.file_path
                    ),
                    startPosition: index,
                  })
                "
              />
            </div>
          </template>
        </van-field>
        <van-field
          label="现场音频"
          v-if="detail.fault_file_mp3_arr.length !== 0"
        >
          <template #input>
            <div style="width: 100%">
              <audio
                controls
                style="width: 100%; height: 30px"
                v-for="(mp3, index) in detail.fault_file_mp3_arr"
                :key="index"
                :src="mp3.file_path"
              >
                您的浏览器不支持 audio 标签。
              </audio>
            </div>
          </template>
        </van-field>
        <van-field
          label="现场视频"
          v-if="detail.fault_file_mp4_arr.length !== 0"
        >
          <template #input>
            <div style="width: 100%">
              <video
                controls
                style="margin-right: 5px; width: 75px; height: 75px"
                v-for="(mp4, index) in detail.fault_file_mp4_arr"
                :key="index"
                :poster="mp4.thumb_pic"
                :src="mp4.file_path"
              >
                您的浏览器不支持 video 标签。
              </video>
            </div>
          </template>
        </van-field>
      </van-cell-group>

      <!-- 维修员 -->
      <van-cell-group style="margin-top: 10px" v-if="detail.repair_name">
        <van-field label="维修员" v-model="detail.repair_name" readonly>
          <template #extra>
            <van-button round size="mini" :color="colors[0]">{{
              detail.repair_state_name
            }}</van-button>
          </template>
        </van-field>
        <van-field
          label="派工时间"
          v-model="detail.dispatch_time_name"
          readonly
        />
        <van-field
          label="接单时间"
          v-model="detail.accept_time_name"
          readonly
        />
        <van-field
          v-if="detail.repair_end_time_name"
          label="完成时间"
          v-model="detail.repair_end_time_name"
          readonly
        />

        <!-- 特殊工单 -->
        <template style="margin-top: 10px" v-if="detail.collection_id !== '1'">
          <van-field
            label="特殊工单"
            v-model="detail.collection_name"
            readonly
          />
          <van-field
            v-if="detail.collection_note"
            v-model="detail.collection_note"
            rows="4"
            autosize
            label="特殊工单备注"
            type="textarea"
            show-word-limit
            readonly
          />
        </template>
        <!-- 特殊工单 end -->

        <van-field
          v-if="detail.repair_state === '3'"
          v-model="detail.repair_not_note"
          rows="2"
          autosize
          label="无法维修原因"
          type="textarea"
          show-word-limit
          readonly
        />
        <van-field
          v-model="detail.repair_end_note"
          rows="4"
          autosize
          label="工作描述"
          type="textarea"
          show-word-limit
          readonly
        />
        <van-field
          label="现场图片"
          v-if="detail.repair_file_jpg_arr.length !== 0"
        >
          <template #input>
            <van-image
              style="margin-right: 10px"
              v-for="(file, index) in detail.repair_file_jpg_arr"
              width="80"
              height="80"
              fit="cover"
              :key="index"
              :src="file.file_path"
              @click="
                ImagePreview({
                  images: detail.repair_file_jpg_arr.map(
                    (file) => file.file_path
                  ),
                  startPosition: index,
                })
              "
            />
          </template>
        </van-field>
      </van-cell-group>
      <van-cell
        v-if="detail.part_use_data.length"
        title="配件清单"
        is-link
        :value="detail.part_use_data.length"
        @click="partRefClick"
      />
      <van-cell
        v-if="detail.wage_use_data.length"
        title="工时清单"
        is-link
        :value="detail.wage_use_data.length"
        @click="workTimeRefClick"
      />
      <!-- 维修员 end -->

      <!-- 评价 -->
      <van-cell-group style="margin-top: 10px" v-if="detail.progre_state > '3'">
        <van-field label="评价人" v-model="detail.appraise_name" readonly />
        <van-field
          label="服务评价"
          v-model="detail.appraise_result_name"
          readonly
        />
        <van-field
          label="评价时间"
          v-model="detail.appraise_time_name"
          readonly
        />
        <template v-if="userInfo.comment_stars === 'on'">
          <div class="appraise-list" style="max-height: 5000px">
            <div
              v-for="item in detail.appraise_result_user"
              :key="item.user_ids"
            >
              <van-field label="维修员：" readonly>
                <template #input>
                  {{ item.name }}
                </template>
              </van-field>
              <van-field label="维修速度" readonly>
                <template #input>
                  <van-rate
                    v-model="item.speed_result"
                    :size="25"
                    color="#ffd21e"
                    void-icon="star"
                    void-color="#eee"
                  />
                </template>
              </van-field>
              <van-field label="专业水平" readonly>
                <template #input>
                  <van-rate
                    v-model="item.professional_result"
                    :size="25"
                    color="#ffd21e"
                    void-icon="star"
                    void-color="#eee"
                  />
                </template>
              </van-field>
              <van-field label="服务态度" readonly>
                <template #input>
                  <van-rate
                    v-model="item.serve_result"
                    :size="25"
                    color="#ffd21e"
                    void-icon="star"
                    void-color="#eee"
                  />
                </template>
              </van-field>
              <van-field
                v-model="item.praise_notes"
                rows="2"
                autosize
                label="评价内容"
                placeholder="请输入评价内容"
                type="textarea"
                show-word-limit
              />
            </div>
          </div>
        </template>
      </van-cell-group>
      <!-- 应收费用 -->
      <van-cell-group
        style="margin-top: 10px; padding-top: 1px"
        v-if="detail.progre_state > 2"
        title="应收费用："
      >
        <template v-for="cost in detail.repair_cost" :key="cost.item_id">
          <van-divider
            content-position="left"
            :style="{ color: '#969799', borderColor: '#969799' }"
          >
            {{ cost.item_name }}</van-divider
          >
          <van-field
            label="费用"
            :modelValue="cost.use_cost + ' 元'"
            readonly
          />
          <!-- <van-field label="数量" v-model="cost.use_amount" readonly /> -->
          <div v-if="cost.item_note" class="cost-note">
            {{ cost.item_note }}
          </div>
        </template>
        <div class="cost-total">总额：{{ costTotal }} 元</div>
      </van-cell-group>
      <div style="height: 50px"></div>
    </div>
    <div class="buttons">
      <template v-for="button in detail.button_arr" :key="button.button_id">
        <van-button
          size="small"
          class="button"
          type="primary"
          @click="buttonClick(button.button_id)"
          >{{ button.word }}</van-button
        >
      </template>
    </div>

    <!-- 维修进度 -->
    <process
      v-model:show="process.show"
      :detail="detail"
      @submit="process.onSubmit"
    />
    <!-- part -->
    <part
      v-model:show="partState.show"
      :default="partDefault"
      @submit="partSubmit"
      ref="partRef"
    />
    <!-- 选择工作时间 -->
    <work-time
      v-model:show="workTimeState.show"
      :default="workTimeDefault"
      @submit="workTimeSubmit"
      ref="workTimeRef"
    />
    <!-- 选择派工人员 -->
    <user v-model:show="userSelector.show" @submit="userSelector.onSubmit" />
    <!-- 评价弹窗 -->
    <van-dialog
      v-model:show="appraise.show"
      :beforeClose="appraise.beforeClose"
      title="评价"
      show-cancel-button
    >
      <div
        v-if="detail.repair_state === '3'"
        style="padding: 10px 0 0 15px; color: red; font-size: 12px"
      >
        此单据无法维修，具体原因{{ detail.collection_name }}（{{
          detail.repair_not_note
        }}）
      </div>
      <van-field label="处理结果" readonly>
        <template #input>
          <van-radio-group
            v-model="appraise.repairState"
            direction="horizontal"
          >
            <van-radio name="2">已解决</van-radio>
            <van-radio name="1">未解决</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <template v-if="appraise.repairState === '2'">
        <van-field label="评价等级" readonly>
          <template #input>
            <van-radio-group
              v-model="appraise.appraiseResult"
              direction="horizontal"
            >
              <van-radio name="1">优</van-radio>
              <van-radio name="2">良</van-radio>
              <van-radio name="3">差</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <template v-if="userInfo.comment_stars === 'on'">
          <div class="appraise-list">
            <div
              v-for="item in appraise.appraise_user_json"
              :key="item.user_ids"
            >
              <van-field label="维修员：" readonly>
                <template #input>
                  {{ item.name }}
                </template>
              </van-field>
              <van-field label="维修速度" readonly>
                <template #input>
                  <van-rate
                    v-model="item.speed_result"
                    :size="25"
                    color="#ffd21e"
                    void-icon="star"
                    void-color="#eee"
                  />
                </template>
              </van-field>
              <van-field label="专业水平" readonly>
                <template #input>
                  <van-rate
                    v-model="item.professional_result"
                    :size="25"
                    color="#ffd21e"
                    void-icon="star"
                    void-color="#eee"
                  />
                </template>
              </van-field>
              <van-field label="服务态度" readonly>
                <template #input>
                  <van-rate
                    v-model="item.serve_result"
                    :size="25"
                    color="#ffd21e"
                    void-icon="star"
                    void-color="#eee"
                  />
                </template>
              </van-field>
              <van-field
                v-model="item.praise_notes"
                rows="2"
                autosize
                label="评价内容"
                placeholder="请输入评价内容"
                type="textarea"
                show-word-limit
              />
            </div>
          </div>
        </template>
      </template>
      <template v-else>
        <div style="color: #999; font-size: 12px; padding: 5px 15px">
          驳回至维修员重新处理
        </div>
        <van-field
          v-model="appraise.rejectNote"
          rows="4"
          autosize
          label="驳回说明"
          placeholder="请输入驳回说明"
          type="textarea"
          show-word-limit
        />
      </template>
    </van-dialog>
    <!-- 审核弹窗 -->
    <van-dialog
      v-model:show="apply.show"
      title="审核"
      show-cancel-button
      @confirm="apply.onConfirm"
    >
      <van-field label="审核结果" readonly>
        <template #input>
          <van-radio-group v-model="apply.applyState" direction="horizontal">
            <van-radio name="2">通过</van-radio>
            <van-radio name="1">不通过</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <div style="color: red; font-size: 12px; padding: 5px 15px">
        确认此工单已经结束，并检查使用的配件是否正确无误！
      </div>
      <van-field
        v-model="apply.applyNote"
        rows="4"
        autosize
        label="备注"
        placeholder="请输入备注"
        type="textarea"
        show-word-limit
      />
    </van-dialog>
    <!-- 弹出日志 -->
    <log v-model:show="showLog" :data="detail.repair_logs"></log>
    <!-- 转正式弹窗 -->
    <van-dialog
      v-model:show="apply2.show"
      title="转正式"
      show-cancel-button
      @confirm="apply2.onConfirm"
    >
      <van-field label="是否通过" readonly>
        <template #input>
          <van-radio-group v-model="apply2.applyState" direction="horizontal">
            <van-radio name="2">通过</van-radio>
            <van-radio name="1">不通过</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        v-model="apply2.applyNote"
        rows="4"
        autosize
        label="备注"
        placeholder="请输入备注"
        type="textarea"
        show-word-limit
      />
    </van-dialog>
    <!-- 退单弹窗 -->
    <van-dialog
      v-model:show="returnInfo.show"
      title="退单"
      show-cancel-button
      @confirm="returnInfo.onConfirm"
    >
      <van-field label="退单方式" readonly>
        <template #input>
          <van-radio-group
            v-model="returnInfo.return_state"
            direction="horizontal"
          >
            <van-radio name="1">退回工单池</van-radio>
            <van-radio name="2">退回报修人</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        v-model="returnInfo.return_note"
        rows="4"
        autosize
        label="备注"
        placeholder="请输入备注"
        type="textarea"
        show-word-limit
      />
    </van-dialog>
  </div>
</template>
<script>
import { repairService, partService, wageService } from "@/service";
import { useRoute, useRouter } from "vue-router";
import { computed, nextTick, reactive, ref } from "vue";
import Process from "./component/Process.vue";
import { Dialog, Toast, ImagePreview } from "vant";
import Part from "./component/Part.vue";
import { templateRef } from "@vueuse/core";
import Log from "./component/Log.vue";
import WorkTime from "./component/WorkTime.vue";
import { useStore } from "@/store";

export default {
  name: "Detail",
  components: {
    Process,
    Part,
    Log,
    WorkTime,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const { id } = route.params;

    const store = useStore();
    const userInfo = computed(() => store.state.userInfo);
    // list
    const colors = ["#3eaaf7", "#ff9800", "#ff5722", "#4caf50", "#9e9e9e"];

    const onClickLeft = () => {
      router.go(-1);
    };
    const detail = reactive({});
    const getDetail = async () => {
      const { data } = await repairService.getDetail(id);
      Object.assign(detail, data[0]);
      appraise.appraise_user_json = detail.appraise_result_user.map((item) => {
        return {
          user_ids: item.user_ids,
          serve_result: Number(userInfo.value.default_stars_num),
          professional_result: Number(userInfo.value.default_stars_num),
          speed_result: Number(userInfo.value.default_stars_num),
          praise_notes: "",
          workorder_id: item.workorder_id,
          name: item.name,
        };
      });
    };
    getDetail();
    // 报修人姓名
    const repairName = computed(() => {
      return `${detail.department_name} - ${detail.fault_name}`;
    });
    // 派工
    const userSelector = reactive({
      show: false,
      onSubmit() {},
    });
    // 维修过程
    const process = reactive({
      show: false,
      onSubmit() {},
    });
    // 评价
    const appraise = reactive({
      show: false,
      repairState: "2",
      appraiseResult: "1",
      rejectNote: "",
      appraiseNote: "",
      appraise_user_json: [],
      speed_result: Number(userInfo.value.default_stars_num),
      professional_result: Number(userInfo.value.default_stars_num),
      serve_result: Number(userInfo.value.default_stars_num),
      onConfirm() {},
      beforeClose(action) {
        if (!action || action === "cancel") return true;
        if (appraise.repairState === "1" && !appraise.rejectNote) {
          Toast.fail("请输入驳回说明");
          return false;
        }
        appraise.onConfirm();
        return true;
      },
    });
    // 审核
    const apply = reactive({
      show: false,
      applyState: "1",
      applyNote: "",
      onConfirm() {},
    });
    // 退单
    const returnInfo = reactive({
      show: false,
      return_state: "1",
      return_note: "",
      onConfirm() {},
    });
    // 转正式
    const apply2 = reactive({
      show: false,
      applyState: "2",
      applyNote: "",
      onConfirm() {},
    });
    // 配件
    const partRef = templateRef("partRef");
    const partRefClick = () => {
      partRef.value.openDetail();
    };
    const partDefault = computed(() => {
      const o = {};
      detail.part_use_data?.forEach((part) => {
        o[part.part_id] = {
          number: Number(part.use_num),
          price: part.price,
          id: part.part_id,
          part_name: part.part_name,
          part_model: part.part_model,
        };
      });
      return o;
    });
    const partState = reactive({
      show: false,
    });
    const partSubmit = async (value) => {
      const o = {};
      Object.keys(value).forEach((key) => {
        const oldNumber = partDefault.value[key]?.number || 0;
        const newNumber = value[key].number;
        if (newNumber === oldNumber) return;
        if (newNumber == 0) {
          if (oldNumber > 0) {
            o[key] = newNumber;
            return;
          }
          return;
        }
        o[key] = newNumber;
      });
      partState.show = false;
      try {
        // if (Object.keys(o).length === 0) return;
        await partService.expendPart({
          id: detail.id,
          part_json: JSON.stringify(o),
        });
      } catch (error) {
        console.log(error);
      } finally {
        detail.id = "";
        await nextTick();
        getDetail();
      }
    };
    // 工作时间
    const workTimeRef = templateRef("workTimeRef");
    const workTimeRefClick = () => {
      workTimeRef.value.openDetail();
    };
    const workTimeDefault = computed(() => {
      const o = {};
      detail.wage_use_data?.forEach((wage) => {
        o[wage.wage_id] = {
          number: Number(wage.use_num),
          // price: wage.price,
          // id: wage.wage_id,
          // wage_name: wage.wage_name,
          // part_model: wage.part_model,
        };
      });
      return o;
    });
    const workTimeState = reactive({
      show: false,
    });
    const workTimeSubmit = async (value) => {
      const o = {};
      Object.keys(value).forEach((key) => {
        if (value[key].number == 0) return;
        o[key] = value[key].number;
      });
      workTimeState.show = false;
      // if (Object.keys(o).length === 0) return;
      try {
        await wageService.expendWage({
          id: detail.id,
          wage_json: JSON.stringify(o),
        });
      } catch (error) {
        console.log(error);
      } finally {
        detail.id = "";
        await nextTick();
        getDetail();
      }
    };
    // 应收费用
    const costTotal = computed(() => {
      return detail.repair_cost.reduce((p, c) => {
        return p + Number(c.use_cost);
      }, 0);
    });
    // 日志
    const showLog = ref(false);
    const buttonClick = async (buttonId) => {
      try {
        switch (buttonId) {
          // 接单
          case 1:
            await repairService.acceptOrder(id);
            Toast.success("接单成功！");
            break;
          // 派工
          case 2: {
            userSelector.show = true;
            const checked = await new Promise((resolve) => {
              userSelector.onSubmit = (checked) => {
                resolve(checked);
              };
            });
            await repairService.dispatchOrder(
              id,
              checked.map((item) => item.id).join()
            );
            Toast.success("指派成功！");
            break;
          }
          // 维修过程
          case 3: {
            process.show = true;
            const body = await new Promise((resolve) => {
              process.onSubmit = (value) => {
                resolve(value);
              };
            });
            await repairService.repairOrder(body);
            Toast.success("提交完成");
            break;
          }
          // 退单
          case 4:
            returnInfo.show = true;
            await new Promise((resolve) => {
              returnInfo.onConfirm = () => {
                resolve(true);
              };
            });
            await repairService.returnOrder({
              id: detail.id,
              return_state: returnInfo.return_state,
              return_note: returnInfo.return_note,
            });
            Toast.success("退单成功！");
            break;
          // 退单
          case 5:
            await Dialog.confirm({
              title: "是否删除工单",
            });
            await repairService.delOrder(id);
            Toast.success("删除成功！");
            break;
          // 评价
          case 6: {
            appraise.show = true;
            await new Promise((resolve) => {
              appraise.onConfirm = () => {
                resolve(true);
              };
            });
            const query = {
              id: detail.id,
              repair_state: appraise.repairState,
              reject_note: appraise.rejectNote,
              appraise_result: appraise.appraiseResult,
              appraise_note: appraise.appraiseNote,
            };
            if (
              appraise.repairState === "2" &&
              userInfo.value.comment_stars === "on"
            ) {
              const o = {};
              appraise.appraise_user_json.forEach((item) => {
                o[
                  item.user_ids
                ] = `${item.serve_result},${item.professional_result},${item.speed_result},${item.praise_notes}`;
              });
              query.appraise_user_json = JSON.stringify(o);
            }
            await repairService.appraiseOrder(query);
            Toast.success(
              appraise.repairState === "1" ? "工单驳回成功!" : "评价成功！"
            );
            break;
          }
          // 填配件
          case 7: {
            partState.show = true;
            return;
          }
          // 审核
          case 8: {
            apply.show = true;
            await new Promise((resolve) => {
              apply.onConfirm = () => {
                resolve(true);
              };
            });
            await repairService.applyOrder({
              id: detail.id,
              apply_state: apply.applyState,
              apply_note: apply.applyNote,
            });
            Toast.success("审核成功！");
            break;
          }
          case 9: {
            apply2.show = true;
            await new Promise((resolve) => {
              apply2.onConfirm = () => {
                resolve(true);
              };
            });
            await repairService.applyAnticipateOrder({
              id: detail.id,
              apply_state: apply2.applyState,
              apply_note: apply2.applyNote,
            });
            Toast.success("转正式成功！");
            break;
          }
          // 填工时
          case 10: {
            workTimeState.show = true;
            return;
          }
          case 11:
            await Dialog.confirm({
              title: "是否恢复工单",
            });
            await repairService.recoveryOrder(id);
            Toast.success("恢复工单！");
            break;
          // 接单
          case 12:
            await repairService.grabOrder(id);
            Toast.success("抢单成功！");
            break;
          default:
            break;
        }
        // onClickLeft();
        detail.id = "";
        await nextTick();
        getDetail();
      } catch (error) {
        console.log("错误", error);
      }
    };

    return {
      colors,
      detail,
      onClickLeft,
      buttonClick,
      userSelector,
      process,
      ImagePreview,
      appraise,
      apply,
      apply2,
      returnInfo,
      repairName,
      partState,
      partDefault,
      partSubmit,
      partRefClick,
      costTotal,
      showLog,
      workTimeRefClick,
      workTimeDefault,
      workTimeState,
      workTimeSubmit,
      userInfo,
    };
  },
};
</script>
<style lang="less" scoped>
.appraise-list {
  padding: 10px 0;
  background: #f0f0f0;
  max-height: 300px;
  overflow: auto;
}
.cost-name {
  padding: 8px 15px;
}
.cost-note {
  padding: 10px 15px 5px;
  font-size: 12px;
  color: #969799;
}
.cost-total {
  padding: 10px 15px;
  font-size: 12px;
  color: #969799;
}
.detail {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 46px);
  .inner {
    flex: 1;
    min-height: 0;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }
  .buttons {
    background: #fff;
    display: flex;
    padding: 10px 5px;
    justify-content: space-between;
    flex-wrap: nowrap;
    .button {
      flex: 1;
      margin: 0 5px;
      :deep(.van-button__text) {
        white-space: nowrap;
      }
    }
  }
}
</style>
